import React from "react";
import "./UF.css";
import { Link } from "react-router-dom";

export default function UltraFiltrationPage() {
  return (
    <main className="ultra-filtration-page">

      {/* Hero Section */}
      <section className="uf-hero" style={{background:"url('/images/UF-2.png'),bottom/cover no-repeat",}}>
        <div className="uf-hero-overlay">
          <h1>Ultra Filtration Systems</h1>
          <p>Membrane technology for purity, reliability, and sustainability.</p>
          <div className="uf-hero-actions">
          <Link to="/contact"> <button className="uf-btn-primary">Get a Quote</button></Link>  
            <a href="/Brochure.pdf" download className="uf-btn-secondary">Download Brochure</a>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="uf-intro">
  <div className="uf-intro-grid">
    <div className="uf-intro-text">
      <h2>Introduction</h2>
      <p>
        Ultra Filtration (UF) is a pressure-driven membrane process that removes suspended solids,
        bacteria, and viruses. It ensures consistent water quality and is widely applied across
        industrial, municipal, and commercial sectors.
      </p>
      <p>
        Crystal Drops offers a series of ultra filtration membranes designed to act as a robust
        barrier against suspended particles and microorganisms. These systems produce consistent,
        high-quality permeate, making them ideal for applications such as potable water treatment,
        pre-treatment for reverse osmosis (RO), food and beverage processing, and wastewater reuse.
      </p>
    </div>
    <div className="uf-intro-visual">
      <img src="/images/UF-1.png" alt="Ultra Filtration System" loading="lazy" />
    </div>
  </div>
</section>

      {/* Applications Section */}
    <section className="uf-applications">
  <h2>Applications</h2>
  <div className="uf-app-zigzag">
    <div className="uf-app-item left">
      <span className="uf-app-icon">⚙️</span>
      <div className="uf-app-content">
        <h3>Pre-treatment Filtration</h3>
        <p>Reliable barrier for suspended solids before advanced treatment stages.</p>
      </div>
    </div>
    <div className="uf-app-item right">
      <span className="uf-app-icon">💧</span>
      <div className="uf-app-content">
        <h3>Water Treatment & Purification</h3>
        <p>Ensures safe, consistent water quality for municipal and commercial use.</p>
      </div>
    </div>
    <div className="uf-app-item left">
      <span className="uf-app-icon">♻️</span>
      <div className="uf-app-content">
        <h3>Wastewater Recycling</h3>
        <p>Enables reuse of treated effluent for sustainable operations.</p>
      </div>
    </div>
    <div className="uf-app-item right">
      <span className="uf-app-icon">🏭</span>
      <div className="uf-app-content">
        <h3>Industrial Process & Waste Fluid Treatment</h3>
        <p>Protects equipment and improves efficiency in industrial water cycles.</p>
      </div>
    </div>
  </div>
  <p className="uf-app-note">
    UF adapts across diverse sectors, ensuring safe and sustainable water use.
  </p>
</section>

      {/* Advantages Section */}
  <section className="uf-advantages">
  <h2>Advantages</h2>
  <div className="uf-adv-timeline">
    {[
      { id: 1, title: "High Tensile Strength", desc: "Durable membranes that withstand operational stress and maintain integrity." },
      { id: 2, title: "Enhanced Hydrophilicity", desc: "Improved water permeability for efficient filtration performance." },
      { id: 3, title: "Low Fouling", desc: "Resists clogging and scaling, reducing maintenance needs." },
      { id: 4, title: "Consistent, High Quality Permeate", desc: "Delivers stable output across varying feed conditions." },
      { id: 5, title: "Sharp Rejection Profile", desc: "Precisely removes contaminants while retaining essential minerals." },
      { id: 6, title: "Long Lifespan", desc: "Extended membrane service life with proper care." },
      { id: 7, title: "Small Footprint", desc: "Compact design saves valuable installation space." },
    ].map(step => (
      <div className="uf-adv-step" key={step.id}>
        <span className="uf-step-marker">{step.id}</span>
        <div>
          <h3>{step.title}</h3>
          <p>{step.desc}</p>
        </div>
      </div>
    ))}
  </div>
</section>

    </main>
  );
}